// 每隔 ms 重畫一次的「現在」（「已開 N 分鐘」這類相對時間用）。
import { useEffect, useState } from 'react';

export function useNow(ms = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), ms);
    return () => window.clearInterval(id);
  }, [ms]);
  return now;
}
